import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import PropTypes from "prop-types";
import { Suspense, lazy, useEffect, useState } from "react";

import ReactQueryDevToolsPortal from "./ReactQueryDevToolsPortal";
import { startCachePersistence } from "./queryCache";
import { queryClient } from "./queryClient";

const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/lib/index.prod.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

export function ReactQueryProvider({ children }) {
  const [showDevtools, setShowDevtools] = useState(false);

  useEffect(() => {
    window.toggleDevtools = () => setShowDevtools((old) => !old);
  }, []);

  useEffect(() => {
    return startCachePersistence(queryClient);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {!process.env.REACT_APP_Hide_Query_Dev_Tools && (
        <ReactQueryDevToolsPortal>
          <ReactQueryDevtools position="bottom-right" />
        </ReactQueryDevToolsPortal>
      )}
      {showDevtools && (
        <Suspense fallback={null}>
          <ReactQueryDevToolsPortal>
            <ReactQueryDevtoolsProduction />
          </ReactQueryDevToolsPortal>
        </Suspense>
      )}
    </QueryClientProvider>
  );
}

ReactQueryProvider.propTypes = {
  children: PropTypes.node,
};
